require('../../modules/es6.date.now');
module.exports = require('../../modules/_core').Date.now;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/date/now.js
// module id = 557
// module chunks = 0